import { createQueryKeys } from "@lukemorales/query-key-factory";

import { listConsentDocuments } from "../api/consentDocuments";
import { ConsentDocumentsRequest } from "../types/consentDocuments";

export const consentDocumentsQueryOptionsFactory = createQueryKeys(
  "consent-documents",
  {
    list: ({ organizationId }: ConsentDocumentsRequest) => ({
      queryKey: [organizationId],
      queryFn: () => listConsentDocuments({ organizationId }),
    }),
  },
);
